import { useState } from 'react'
import { Link, useLocation } from 'react-router'

import { useI18n } from '../../lib/i18n'
import { WORKING, paceOf } from '../../upload/job'
import { leadingJob } from '../../upload/jobs'
import { percentOf, useUploads, useUploadsState } from '../../upload/UploadsProvider'
import { useJobLabels } from './labels'
import { OutcomeBar } from './Outcomes'

/**
 * The upload under way, in a corner of every other page, so the user sees it go on and what needs
 * them while working elsewhere. It folds to its percentage; it is gone once no job waits or works.
 */
export function UploadDock() {
  const { t, lang } = useI18n()
  const labels = useJobLabels()
  const uploads = useUploads()
  const { jobs } = useUploadsState()
  const { pathname } = useLocation()
  const [folded, setFolded] = useState(false)
  const job = leadingJob(jobs)
  if (!job || job.phase === 'done' || pathname.startsWith('/uploads')) return null

  const percent = percentOf(job)
  const needs = job.tally.counts.needs
  if (folded) {
    return (
      <button
        type="button"
        className="upload-dock folded"
        aria-label={t('openUploads', { percent: String(percent) })}
        onClick={() => setFolded(false)}
      >
        {t('uploadsDock')} · {percent} %{needs > 0 && <span className="warning-text"> · {needs}</span>}
      </button>
    )
  }
  const pace = paceOf(job)
  return (
    <section className="upload-dock" aria-labelledby="upload-dock-title">
      <header>
        <h2 id="upload-dock-title">{t('uploadsDock')}</h2>
        <button type="button" className="secondary compact" aria-label={t('foldUploads')} onClick={() => setFolded(true)}>
          –
        </button>
      </header>
      <p>
        <strong>{labels.title(job)}</strong> · {labels.phase(job)}
        {WORKING.has(job.phase) && ` · ${percent} %`}
      </p>
      <OutcomeBar counts={job.tally.counts} />
      {pace && (
        <p className="muted small">
          {t('paceFiles', { rate: pace.perSecond.toLocaleString(lang, { maximumFractionDigits: 1 }) })} ·{' '}
          {pace.secondsLeft < 60 ? t('underAMinuteLeft') : t('minutesLeft', { count: String(Math.round(pace.secondsLeft / 60)) })}
        </p>
      )}
      {needs > 0 && <p className="warning-text small">{t('needYou', { count: String(needs) })}</p>}
      <div className="actions">
        {job.phase === 'uploading' && (
          <button type="button" className="secondary compact" onClick={() => uploads.pause(job.id)}>
            {t('pauseUpload')}
          </button>
        )}
        <Link to={`/uploads/${job.id}`} className="button compact">
          {job.phase === 'checked' ? t('confirmToStart') : t('allUploads')}
        </Link>
      </div>
    </section>
  )
}
